import React from 'react';
import classnames from 'classnames';
const { useState } = React;
import styles from './styles.scss';

import { Button } from '@densityco/ui';
import {fps30} from '../../utils/constants';

type CaptureTag = {
  id: number,
  name: string,
  created_at: string,
  start_frame: number,
};

type CaptureTagViewerProps = {
  tags: Array<CaptureTag>,
  onNavigateToTag: (tag: CaptureTag) => void,
};

function convertFrameToTime(frame: number, framesPerSecond: number = fps30): string {
  const seconds = frame / framesPerSecond;
  return `${Math.floor(seconds / 60)}:${Math.round(seconds % 60).toString().padStart(2, '0')}`;
}

const Tag: React.FunctionComponent<{tag: CaptureTag, truncate: boolean, onClick: () => void}> = ({tag, truncate, onClick}) => (
  <div className={classnames(styles.tag, {[styles.truncate]: truncate})} onClick={e => {
    onClick();
    e.stopPropagation();
  }}>
    {tag.name} (<span className={styles.tagTimestamp}>{convertFrameToTime(tag.start_frame)}</span>)
  </div>
);

const CaptureTagViewer: React.FunctionComponent<CaptureTagViewerProps> = ({tags, onNavigateToTag}) => {
  const [ open, setOpen ] = useState(false);

  if (tags.length === 0) {
    return <span className={styles.detailText}>No Tags</span>;
  }

  return (
    <div style={{width: '100%'}}>
      {open ? <div className={styles.backdrop} onMouseEnter={() => setOpen(false)} /> : null}
      <div style={{position: 'relative', width: '100%'}} onMouseEnter={() => {
        if (tags.length > 1) {
          setTimeout(() => {
            setOpen(true);
          }, 250);
        }
      }}>
        <div className={classnames(styles.popover, {[styles.open]: open})}>
          <div className={styles.tagWrapper}>
            {tags.sort((a, b) => a.start_frame - b.start_frame).map(tag => (
              <Tag truncate={false} tag={tag} key={`${tag.id},${tag.created_at}`} onClick={() => onNavigateToTag(tag)} />
            ))}
          </div>
        </div>
        <div className={styles.wrapper}>
          <div className={classnames(styles.tagWrapper, styles.oneLine)}>
            {tags.sort((a, b) => a.start_frame - b.start_frame).map(tag => (
              <Tag truncate={tags.length > 1} key={`${tag.id},${tag.created_at}`} tag={tag} onClick={() => onNavigateToTag(tag)} />
            ))}
          </div>
          {tags.length > 1 ? (
            <span className={styles.detailText} style={{marginLeft: 8}}>{tags.length} total tags</span>
          ) : null}
        </div>
      </div>
    </div>
  );
};
export default CaptureTagViewer;
